import { Injectable } from "@angular/core";
import { AppStore } from "@app/core/store/app.store";
import { environment } from "src/environments/environment";
import { SignalRBaseService } from "./infrastructure/base/signalr-base.service";

const buildUrl = (store: AppStore) => {
  const { Id } = store.sessionAction.getUser();

  return `${environment.signalRAcademicoUrl}/NotificationUserHub?userId=${Id}`;
};

@Injectable()
export class StatusCargaMasivaService extends SignalRBaseService {
  constructor(store: AppStore) {
    super(buildUrl(store), ["ProcesoCargaUpdatedState"]);
  }
}
